import AccordionWithImages from './AccordionWithImages'


export default AccordionWithImages
